"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shapes = require("../../skybase-core/shapes");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SbButton = /*#__PURE__*/function (_PureComponent) {
  _inherits(SbButton, _PureComponent);

  var _super = _createSuper(SbButton);

  function SbButton() {
    var _this;

    _classCallCheck(this, SbButton);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "renderIcon", function (position) {
      var _this$props = _this.props,
          iconPosition = _this$props.iconPosition,
          icon = _this$props.icon,
          loading = _this$props.loading;

      if (loading) {
        if (position === _constants.ICON_LEFT) {
          return /*#__PURE__*/_react.default.createElement("i", {
            className: "sbi-loader"
          });
        }

        return null;
      }

      return icon && position === iconPosition && /*#__PURE__*/_react.default.createElement("i", {
        className: (0, _classnames.default)(icon)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function () {
      var _this$props2 = _this.props,
          onClick = _this$props2.onClick,
          loading = _this$props2.loading;

      if (!loading && onClick) {
        onClick.apply(void 0, arguments);
      }
    });

    return _this;
  }

  _createClass(SbButton, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          intl = _this$props3.intl,
          inputRef = _this$props3.inputRef,
          icon = _this$props3.icon,
          iconPosition = _this$props3.iconPosition,
          loading = _this$props3.loading,
          type = _this$props3.type,
          rest = _objectWithoutProperties(_this$props3, ["children", "className", "intl", "inputRef", "icon", "iconPosition", "loading", "type"]);

      var fontIconClass = 'sbi-';
      var iconLeftClass = 'icon-left';
      var iconRightClass = 'icon-right';
      var btnWithIconClass = 'sb-btn-with-icon';
      var btnWithIconTextClass = 'sb-btn-with-icon-text';
      var buttonClasses = (0, _classnames.default)('sb-btn', className);

      if (loading) {
        buttonClasses = (0, _classnames.default)(buttonClasses, 'loader-button');
      } else if (icon) {
        buttonClasses = (0, _classnames.default)(buttonClasses, btnWithIconClass, iconPosition === _constants.ICON_LEFT ? iconLeftClass : iconRightClass, children ? btnWithIconTextClass : null);
      } else if (className && className.indexOf(btnWithIconClass) !== -1) {
        // Injecting a correct icon-position-class to the button.
        // Basically searches button's children for `fontIconClass`.
        // If the first child has the class, then the `icon-left` is given
        // and when any other child has the class, then the class is changed/rewritten to `icon-right`.
        var iconClass = null;
        var withText = false;

        if (Array.isArray(children)) {
          // more than one children in button ...
          withText = children.length > 1;
          children.forEach(function (item, i) {
            var _item$props, _item$props$className, _item$props$className2;

            if (item === null || item === void 0 ? void 0 : (_item$props = item.props) === null || _item$props === void 0 ? void 0 : (_item$props$className = _item$props.className) === null || _item$props$className === void 0 ? void 0 : (_item$props$className2 = _item$props$className.includes) === null || _item$props$className2 === void 0 ? void 0 : _item$props$className2.call(_item$props$className, fontIconClass)) {
              iconClass = i === 0 ? iconLeftClass : iconRightClass;
            }
          });
        } else if (_typeof(children) === 'object') {
          var _children$props, _children$props$class, _children$props$class2;

          // because a string cannot be an icon ...
          if (children === null || children === void 0 ? void 0 : (_children$props = children.props) === null || _children$props === void 0 ? void 0 : (_children$props$class = _children$props.className) === null || _children$props$class === void 0 ? void 0 : (_children$props$class2 = _children$props$class.includes) === null || _children$props$class2 === void 0 ? void 0 : _children$props$class2.call(_children$props$class, fontIconClass)) {
            iconClass = iconLeftClass;
          }
        }

        if (iconClass) {
          buttonClasses = (0, _classnames.default)(buttonClasses, iconClass, withText ? btnWithIconTextClass : null);
        }
      }

      return /*#__PURE__*/_react.default.createElement("button", _extends({}, rest, {
        type: type,
        ref: inputRef,
        className: buttonClasses,
        onClick: this.handleOnClick
      }), this.renderIcon(_constants.ICON_LEFT), children, this.renderIcon(_constants.ICON_RIGHT));
    }
  }]);

  return SbButton;
}(_react.PureComponent);

exports.SbButton = SbButton;

_defineProperty(SbButton, "propTypes", {
  className: _propTypes.default.string,
  inputRef: _shapes.PropTypeRef,
  icon: _propTypes.default.string,
  iconPosition: _propTypes.default.oneOf([_constants.ICON_LEFT, _constants.ICON_RIGHT]),
  loading: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  type: _propTypes.default.string
});

_defineProperty(SbButton, "defaultProps", {
  className: null,
  inputRef: function inputRef() {},
  icon: null,
  iconPosition: _constants.ICON_LEFT,
  loading: false,
  onClick: null,
  type: 'button'
});
//# sourceMappingURL=sb-button.js.map